const config = require("../config");

import React, { useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import * as Actions from "../actions";

export default function ThankYouForTryingDialog(props) {
  return (
    <React.Fragment>
      {props.open ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-full md:w-9/12 my-6 mx-auto">
              {/*content*/}
              <div className="min-h-full text-gray-600 border-0 py-4 px-6 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none justify-between">
                {/*body*/}
                <div className="flex flex-col justify-start">
                  <div className="relative gap-1 flex flex-row w-auto flex-wrap text-2xl pb-4">
                    Thank you for trying out automate.video!
                  </div>

                  <div className="mt-6 p-6 border-2">
                    <div className="relative gap-1 flex flex-row w-auto flex-wrap text-xl pb-4 ">
                      You'll get your video via email in minutes. In the meanwhile, feel free to continue testing!
                    </div>
                  </div>
                </div>

                {/*footer*/}
                <div className="flex flex-row w-full justify-self-end self-end ">
                  <div className="flex flex-row w-full content-between justify-between mt-3 pt-1">
                    <div className="mb-1 mt-3"></div>
                    <div className="flex items-center justify-end gap-4  ">
                      <button
                        className="py-2 px-5 mr-2 mb-2 text-sm font-bold uppercase text-gray-700 focus:outline-none bg-gray-200 rounded-lg border border-gray-200 hover:bg-gray-300  focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                        type="button"
                        style={{ transition: "all .15s ease" }}
                        onClick={() => {
                          props.handleClose();
                        }}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </React.Fragment>
  );
}
